import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/authuntication/auth-service/login.service';

@Component({
  selector: 'app-confirm-logot',
  templateUrl: './confirm-logot.component.html',
  styleUrls: ['./confirm-logot.component.scss']
})
export class ConfirmLogotComponent implements OnInit {
  constructor(public dialog: MatDialogRef<ConfirmLogotComponent>, private _AuthService: LoginService) { }

  ngOnInit(): void { }

  isLogout() {
    this._AuthService.logout();
    this.dialog.close(true)
  }

  cancelForm() {
    this.dialog.close(false)
  }

}
